import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { compact } from 'lodash'
import { MoreDots as MoreDots24 } from 'blaze-ui/icons/24'
import { Button as MobileButton } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { DesignMenuDrawer } from 'components/DesignMenu/DesignMenuDrawer'
import { ShareButton } from 'components/Design/TopBar/ShareButton'
import { CanView } from 'components/Can'
import { UserRole } from 'types'
import { useRootStore } from 'stores/RootStore'
import { Header } from './Header'
import { VideoEditorHeaderProps } from './Types'
import Styles from './VideoEditorHeader.module.scss'

export const MobileVideoEditorHeader = observer(({ fileId }: VideoEditorHeaderProps) => {
  const { files, drawersStore } = useRootStore()

  useEffect(() => {
    files.fetch(fileId)
  }, [files, fileId])

  const file = files.get(fileId)

  return (
    <Header data-testid="video-editor-header" className={Styles.header}>
      <MobileTopBarContainer.Root>
        {file && (
          <>
            <MobileTopBarContainer.Left>
              <MobileTopBarContainer.BackButton />
            </MobileTopBarContainer.Left>
            <MobileTopBarContainer.Center />
            <MobileTopBarContainer.Right>
              <CanView as={[UserRole.MEMBER, UserRole.SUPER_ADMIN, UserRole.ADMIN]} inWorkspace={file.workspace.id}>
                <ShareButton fileId={file.id} />
              </CanView>
              <MobileButton
                icon={MoreDots24}
                aria-label="File Menu"
                onPress={() =>
                  drawersStore.openDrawer(DesignMenuDrawer, {
                    id: file.id,
                    hiddenKeys: new Set(compact(['rename', 'openInNewTab'])),
                  })
                }
              />
            </MobileTopBarContainer.Right>
          </>
        )}
      </MobileTopBarContainer.Root>
    </Header>
  )
})
